import React from 'react';
import { BenchmarkStats, PriceVerdict } from '../types';
import { formatPrix } from '../utils/priceParsing';

interface BenchmarkBadgeProps {
  stats: BenchmarkStats | null;
  verdict: PriceVerdict;
}

const verdictConfig: Record<PriceVerdict, { bg: string; text: string; dot: string }> = {
  good: { bg: 'bg-green-50', text: 'text-green-700', dot: 'bg-green-500' },
  warning: { bg: 'bg-orange-50', text: 'text-orange-700', dot: 'bg-orange-500' },
  danger: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500' },
  'no-data': { bg: 'bg-gray-50', text: 'text-gray-500', dot: 'bg-gray-400' },
};

const BenchmarkBadge: React.FC<BenchmarkBadgeProps> = ({ stats, verdict }) => {
  const config = verdictConfig[verdict];

  if (!stats || stats.count === 0) {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs ${config.bg} ${config.text}`}>
        <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
        Pas de données
      </span>
    );
  }

  return (
    <div className="group relative">
      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs cursor-default ${config.bg} ${config.text}`}>
        <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
        {formatPrix(stats.min)} - {formatPrix(stats.max)} | moy: {formatPrix(stats.avg)} €
      </span>

      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block z-10">
        <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 whitespace-nowrap shadow-lg">
          <div className="font-medium mb-1">{stats.ouvrageIntitule}</div>
          <div className="space-y-0.5 text-gray-300">
            <div>Min : {formatPrix(stats.min)} €/{stats.unite}</div>
            <div>Max : {formatPrix(stats.max)} €/{stats.unite}</div>
            <div>Moyenne : {formatPrix(stats.avg)} €/{stats.unite}</div>
            <div>Médiane : {formatPrix(stats.median)} €/{stats.unite}</div>
            <div>{stats.count} référence{stats.count > 1 ? 's' : ''}</div>
          </div>
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
        </div>
      </div>
    </div>
  );
};

export default BenchmarkBadge;
